import shortid from 'shortid';

export default {
    props: {
        action: Object,
        /**
         * @type {ValidationAggregator|{}}
         */
        validationAggregator: Object,
        preProcessor: Object,
        isFormUpdating: Boolean,
        newActionPredicate: Function,
        systemEventType: String,
    },
    computed: {
        uniqueId() {
            return shortid.generate();
        },
    },
    data() {
        return {
            asyncDelegateCache: null,
            aggregateName: null,
        };
    },
    methods: {
        getValidationAggregate() {
            return false;
        },
        /**
         * When required this method should be overwritten
         * in the action to trigger special steps to occur
         * before the action can save.
         * @returns {Promise<boolean>}
         */
        async asyncSaveStep() {
            return true;
        },
    },
    created() {
        const aggregate = this.getValidationAggregate();
        if (this.validationAggregator && aggregate) {
            // append unique ID to differentiate multiple instances of the
            // same action
            aggregate.name = `${aggregate.name}_${this.uniqueId}`;
            this.aggregateName = aggregate.name;
            this.validationAggregator.registerComponent(aggregate);
        }
        // register the default async save step
        this.asyncDelegateCache = () => {
            this.preProcessor.bus.$emit('push-action', () => this.asyncSaveStep());
        };
        this.preProcessor.bus.$on('resolve', this.asyncDelegateCache);
    },
    beforeDestroy() {
        this.validationAggregator.deregisterComponent(this.aggregateName);
        this.preProcessor.bus.$off('resolve', this.asyncDelegateCache);
    },
};
